import { useQuery } from "@tanstack/react-query";
import { getUserSubscription } from "src/api/services/user/userSubscriptionService";
import { useAuthContext } from "src/context/AuthContext";

export const useSubscriptionQuery = () => {
  const { getValidToken } = useAuthContext();
  const {
    data: subscriptionResult,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: ["subscription"],
    queryFn: async () => {
      const token = await getValidToken();
      if (!token) throw new Error("Missing JWT token");

      const headers = { Authorization: `Bearer ${token}` };
      return getUserSubscription(headers);
    },
  });

  //TODO investigate how to fetch after BE updated subsciption
  const refetchWithDelay = () => {
    setTimeout(() => {
      refetch();
    }, 500);
  };

  return {
    subscriptionResult,
    isSubscriptionLoading: isLoading,
    isSubscriptionError: isError,
    refetchSubscription: refetchWithDelay,
  };
};
